import U, { Children as Ue, isValidElement as se, cloneElement as he, forwardRef as Fe, useEffect as ae, useReducer as We, useState as Ie, useRef as oe, useLayoutEffect as He } from "react";
import ee from "clsx";
import { jsx as be } from "react/jsx-runtime";
const lt = (e, f) => Ue.map(e, (O, j) => se(O) ? he(O, { ...f, index: j }) : O), dt = (e) => e.split(" ").map((f) => f[0]).slice(0, 2).join("").toUpperCase(), ft = ({ hasError: e = !1, readOnly: f = !1 }) => ee([
  "rounded-md border border-solid",
  "h-10 w-full px-3 py-0",
  "text-base text-grey-08 placeholder:text-sm placeholder:text-grey-04",
  "!shadow-none outline outline-2 !outline-offset-0 !ring-0",
  // !importants to override tailwindcss/forms defaults
  "enabled:bg-grey-transparent-01 disabled:border-grey-03 disabled:bg-grey-transparent-02",
  e ? "border-error-04 outline-error-01" : "border-transparent outline-transparent",
  f ? "!outline-none !border-0" : [
    "enabled:hover:border-grey-transparent-03",
    "enabled:hover:outline-grey-transparent-01",
    "enabled:hover:bg-white enabled:focus:bg-white enabled:active:bg-white",
    "enabled:focus:border-secondary-04 enabled:focus:outline-secondary-01",
    "enabled:active:border-secondary-04 enabled:active:outline-secondary-01"
  ]
]), pt = String.raw, Ae = [
  "bg-tint-aqua",
  "bg-tint-teal",
  "bg-tint-blue",
  "bg-tint-indigo",
  "bg-tint-purple",
  "bg-tint-pink",
  "bg-tint-red",
  "bg-tint-brown",
  "bg-tint-gold",
  "bg-tint-green"
], De = [
  "border-tint-aqua",
  "border-tint-teal",
  "border-tint-blue",
  "border-tint-indigo",
  "border-tint-purple",
  "border-tint-pink",
  "border-tint-red",
  "border-tint-brown",
  "border-tint-gold",
  "border-tint-green"
], Ye = (e, f) => {
  const O = Ke(e);
  return Math.abs(Math.floor(O % f));
}, Ke = (e) => e.split("").reduce((O, j) => O + j.charCodeAt(0) | 0, 0), vt = (e, f) => Ae[Ye(`${e}-${f}`, Ae.length)], mt = (e) => De[Ye(e, De.length)], le = (e) => typeof e == "number" && !isNaN(e), ie = (e) => typeof e == "string", X = (e) => typeof e == "function", ye = (e) => ie(e) || X(e) ? e : null, Pe = (e) => se(e) || ie(e) || X(e) || le(e);
function Xe(e, f, O) {
  O === void 0 && (O = 300);
  const { scrollHeight: j, style: L } = e;
  requestAnimationFrame(() => {
    L.minHeight = "initial", L.height = j + "px", L.transition = `all ${O}ms`, requestAnimationFrame(() => {
      L.height = "0", L.padding = "0", L.margin = "0", setTimeout(f, O);
    });
  });
}
function Te(e) {
  let { enter: f, exit: O, appendPosition: j = !1, collapse: L = !0, collapseDuration: x = 300 } = e;
  return function(g) {
    let { children: d, position: a, preventExitTransition: s, done: v, nodeRef: p, isIn: b } = g;
    const t = j ? `${f}--${a}` : f, n = j ? `${O}--${a}` : O, o = oe(0);
    return He(() => {
      const i = p.current, r = t.split(" "), c = (_) => {
        _.target === p.current && (i.dispatchEvent(new Event("d")), i.removeEventListener("animationend", c), i.removeEventListener("animationcancel", c), o.current === 0 && _.type !== "animationcancel" && i.classList.remove(...r));
      };
      i.classList.add(...r), i.addEventListener("animationend", c), i.addEventListener("animationcancel", c);
    }, []), ae(() => {
      const i = p.current, r = () => {
        i.removeEventListener("animationend", r), L ? Xe(i, v, x) : v();
      };
      b || (s ? r() : (o.current = 1, i.className += ` ${n}`, i.addEventListener("animationend", r)));
    }, [b]), U.createElement(U.Fragment, null, d);
  };
}
function $e(e, f) {
  return { content: e.content, containerId: e.props.containerId, id: e.props.toastId, theme: e.props.theme, type: e.props.type, data: e.props.data || {}, isLoading: e.props.isLoading, icon: e.props.icon, status: f };
}
const q = { list: /* @__PURE__ */ new Map(), emitQueue: /* @__PURE__ */ new Map(), on(e, f) {
  return this.list.has(e) || this.list.set(e, []), this.list.get(e).push(f), this;
}, off(e, f) {
  if (f) {
    const O = this.list.get(e).filter((j) => j !== f);
    return this.list.set(e, O), this;
  }
  return this.list.delete(e), this;
}, cancelEmit(e) {
  const f = this.emitQueue.get(e);
  return f && (f.forEach(clearTimeout), this.emitQueue.delete(e)), this;
}, emit(e) {
  this.list.has(e) && this.list.get(e).forEach((f) => {
    const O = setTimeout(() => {
      f(...[].slice.call(arguments, 1));
    }, 0);
    this.emitQueue.has(e) || this.emitQueue.set(e, []), this.emitQueue.get(e).push(O);
  });
} }, ve = (e) => {
  let { theme: f, type: O, ...j } = e;
  return U.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: f === "colored" ? "currentColor" : `var(--toastify-icon-color-${O})`, ...j });
}, Re = { info: function(e) {
  return U.createElement(ve, { ...e }, U.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}, warning: function(e) {
  return U.createElement(ve, { ...e }, U.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}, success: function(e) {
  return U.createElement(ve, { ...e }, U.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}, error: function(e) {
  return U.createElement(ve, { ...e }, U.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}, spinner: function() {
  return U.createElement("div", { className: "Toastify__spinner" });
} };
function Ge(e) {
  const [, f] = We((t) => t + 1, 0), [O, j] = Ie([]), L = oe(null), x = oe(/* @__PURE__ */ new Map()).current, g = (t) => O.indexOf(t) !== -1, d = oe({ toastKey: 1, displayedToast: 0, count: 0, queue: [], props: e, containerId: null, isToastActive: g, getToast: (t) => x.get(t) }).current;
  function a(t) {
    let { containerId: n } = t;
    const { limit: o } = d.props;
    !o || n && d.containerId !== n || (d.count -= d.queue.length, d.queue = []);
  }
  function s(t) {
    j((n) => t == null ? [] : n.filter((o) => o !== t));
  }
  function v() {
    const { toastContent: t, toastProps: n, staleId: o } = d.queue.shift();
    b(t, n, o);
  }
  function p(t, n) {
    let { delay: o, staleId: i, ...r } = n;
    if (!Pe(t) || function(w) {
      return !L.current || d.props.enableMultiContainer && w.containerId !== d.props.containerId || x.has(w.toastId) && w.updateId == null;
    }(r))
      return;
    const { toastId: c, updateId: _, data: u } = r, { props: m } = d, M = () => s(c), C = _ == null;
    C && d.count++;
    const R = { ...m, style: m.toastStyle, key: d.toastKey++, ...Object.fromEntries(Object.entries(r).filter((w) => {
      let [E, z] = w;
      return z != null;
    })), toastId: c, updateId: _, data: u, closeToast: M, isIn: !1, className: ye(r.className || m.toastClassName), bodyClassName: ye(r.bodyClassName || m.bodyClassName), progressClassName: ye(r.progressClassName || m.progressClassName), autoClose: !r.isLoading && (y = r.autoClose, P = m.autoClose, y === !1 || le(y) && y > 0 ? y : P), deleteToast() {
      const w = $e(x.get(c), "removed");
      x.delete(c), q.emit(4, w);
      const E = d.queue.length;
      if (d.count = c == null ? d.count - d.displayedToast : d.count - 1, d.count < 0 && (d.count = 0), E > 0) {
        const z = c == null ? d.props.limit : 1;
        if (E === 1 || z === 1)
          d.displayedToast++, v();
        else {
          const H = z > E ? E : z;
          d.displayedToast = H;
          for (let F = 0; F < H; F++)
            v();
        }
      } else
        f();
    } };
    var y, P;
    R.iconOut = function(w) {
      let { theme: E, type: z, isLoading: H, icon: F } = w, G = null;
      const J = { theme: E, type: z };
      return F === !1 || (X(F) ? G = F(J) : se(F) ? G = he(F, J) : ie(F) || le(F) ? G = F : H ? G = Re.spinner() : ((te) => te in Re)(z) && (G = Re[z](J))), G;
    }(R), X(r.onOpen) && (R.onOpen = r.onOpen), X(r.onClose) && (R.onClose = r.onClose), R.closeButton = m.closeButton, r.closeButton === !1 || Pe(r.closeButton) ? R.closeButton = r.closeButton : r.closeButton === !0 && (R.closeButton = !Pe(m.closeButton) || m.closeButton);
    let I = t;
    se(t) && !ie(t.type) ? I = he(t, { closeToast: M, toastProps: R, data: u }) : X(t) && (I = t({ closeToast: M, toastProps: R, data: u })), m.limit && m.limit > 0 && d.count > m.limit && C ? d.queue.push({ toastContent: I, toastProps: R, staleId: i }) : le(o) ? setTimeout(() => {
      b(I, R, i);
    }, o) : b(I, R, i);
  }
  function b(t, n, o) {
    const { toastId: i } = n;
    o && x.delete(o);
    const r = { content: t, props: n };
    x.set(i, r), j((c) => [...c, i].filter((_) => _ !== o)), q.emit(4, $e(r, r.props.updateId == null ? "added" : "updated"));
  }
  return ae(() => (d.containerId = e.containerId, q.cancelEmit(3).on(0, p).on(1, (t) => L.current && s(t)).on(5, a).emit(2, d), () => {
    x.clear(), q.emit(3, d);
  }), []), ae(() => {
    d.props = e, d.isToastActive = g, d.displayedToast = O.length;
  }), { getToastToRender: function(t) {
    const n = /* @__PURE__ */ new Map(), o = Array.from(x.values());
    return e.newestOnTop && o.reverse(), o.forEach((i) => {
      const { position: r } = i.props;
      n.has(r) || n.set(r, []), n.get(r).push(i);
    }), Array.from(n, (i) => t(i[0], i[1]));
  }, containerRef: L, isToastActive: g };
}
function ke(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}
function Qe(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}
function qe(e) {
  const [f, O] = Ie(!1), [j, L] = Ie(!1), x = oe(null), g = oe({ start: 0, x: 0, y: 0, delta: 0, removalDistance: 0, canCloseOnClick: !0, canDrag: !1, boundingRect: null, didMove: !1 }).current, d = oe(e), { autoClose: a, pauseOnHover: s, closeToast: v, onClick: p, closeOnClick: b } = e;
  function t(u) {
    if (e.draggable) {
      u.nativeEvent.type === "touchstart" && u.nativeEvent.preventDefault(), g.didMove = !1, document.addEventListener("mousemove", r), document.addEventListener("mouseup", c), document.addEventListener("touchmove", r), document.addEventListener("touchend", c);
      const m = x.current;
      g.canCloseOnClick = !0, g.canDrag = !0, g.boundingRect = m.getBoundingClientRect(), m.style.transition = "", g.x = ke(u.nativeEvent), g.y = Qe(u.nativeEvent), e.draggableDirection === "x" ? (g.start = g.x, g.removalDistance = m.offsetWidth * (e.draggablePercent / 100)) : (g.start = g.y, g.removalDistance = m.offsetHeight * (e.draggablePercent === 80 ? 1.5 * e.draggablePercent : e.draggablePercent / 100));
    }
  }
  function n(u) {
    if (g.boundingRect) {
      const { top: m, bottom: M, left: C, right: R } = g.boundingRect;
      u.nativeEvent.type !== "touchend" && e.pauseOnHover && g.x >= C && g.x <= R && g.y >= m && g.y <= M ? i() : o();
    }
  }
  function o() {
    O(!0);
  }
  function i() {
    O(!1);
  }
  function r(u) {
    const m = x.current;
    g.canDrag && m && (g.didMove = !0, f && i(), g.x = ke(u), g.y = Qe(u), g.delta = e.draggableDirection === "x" ? g.x - g.start : g.y - g.start, g.start !== g.x && (g.canCloseOnClick = !1), m.style.transform = `translate${e.draggableDirection}(${g.delta}px)`, m.style.opacity = "" + (1 - Math.abs(g.delta / g.removalDistance)));
  }
  function c() {
    document.removeEventListener("mousemove", r), document.removeEventListener("mouseup", c), document.removeEventListener("touchmove", r), document.removeEventListener("touchend", c);
    const u = x.current;
    if (g.canDrag && g.didMove && u) {
      if (g.canDrag = !1, Math.abs(g.delta) > g.removalDistance)
        return L(!0), void e.closeToast();
      u.style.transition = "transform 0.2s, opacity 0.2s", u.style.transform = `translate${e.draggableDirection}(0)`, u.style.opacity = "1";
    }
  }
  ae(() => {
    d.current = e;
  }), ae(() => (x.current && x.current.addEventListener("d", o, { once: !0 }), X(e.onOpen) && e.onOpen(se(e.children) && e.children.props), () => {
    const u = d.current;
    X(u.onClose) && u.onClose(se(u.children) && u.children.props);
  }), []), ae(() => (e.pauseOnFocusLoss && (document.hasFocus() || i(), window.addEventListener("focus", o), window.addEventListener("blur", i)), () => {
    e.pauseOnFocusLoss && (window.removeEventListener("focus", o), window.removeEventListener("blur", i));
  }), [e.pauseOnFocusLoss]);
  const _ = { onMouseDown: t, onTouchStart: t, onMouseUp: n, onTouchEnd: n };
  return a && s && (_.onMouseEnter = i, _.onMouseLeave = o), b && (_.onClick = (u) => {
    p && p(u), g.canCloseOnClick && v();
  }), { playToast: o, pauseToast: i, isRunning: f, preventExitTransition: j, toastRef: x, eventHandlers: _ };
}
function ze(e) {
  let { closeToast: f, theme: O, ariaLabel: j = "close" } = e;
  return U.createElement("button", { className: `Toastify__close-button Toastify__close-button--${O}`, type: "button", onClick: (L) => {
    L.stopPropagation(), f(L);
  }, "aria-label": j }, U.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, U.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
}
function Je(e) {
  let { delay: f, isRunning: O, closeToast: j, type: L = "default", hide: x, className: g, style: d, controlledProgress: a, progress: s, rtl: v, isIn: p, theme: b } = e;
  const t = x || a && s === 0, n = { ...d, animationDuration: `${f}ms`, animationPlayState: O ? "running" : "paused", opacity: t ? 0 : 1 };
  a && (n.transform = `scaleX(${s})`);
  const o = ee("Toastify__progress-bar", a ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${b}`, `Toastify__progress-bar--${L}`, { "Toastify__progress-bar--rtl": v }), i = X(g) ? g({ rtl: v, type: L, defaultClassName: o }) : ee(o, g);
  return U.createElement("div", { role: "progressbar", "aria-hidden": t ? "true" : "false", "aria-label": "notification timer", className: i, style: n, [a && s >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: a && s < 1 ? null : () => {
    p && j();
  } });
}
const Ze = (e) => {
  const { isRunning: f, preventExitTransition: O, toastRef: j, eventHandlers: L } = qe(e), { closeButton: x, children: g, autoClose: d, onClick: a, type: s, hideProgressBar: v, closeToast: p, transition: b, position: t, className: n, style: o, bodyClassName: i, bodyStyle: r, progressClassName: c, progressStyle: _, updateId: u, role: m, progress: M, rtl: C, toastId: R, deleteToast: y, isIn: P, isLoading: I, iconOut: w, closeOnClick: E, theme: z } = e, H = ee("Toastify__toast", `Toastify__toast-theme--${z}`, `Toastify__toast--${s}`, { "Toastify__toast--rtl": C }, { "Toastify__toast--close-on-click": E }), F = X(n) ? n({ rtl: C, position: t, type: s, defaultClassName: H }) : ee(H, n), G = !!M || !d, J = { closeToast: p, type: s, theme: z };
  let te = null;
  return x === !1 || (te = X(x) ? x(J) : se(x) ? he(x, J) : ze(J)), U.createElement(b, { isIn: P, done: y, position: t, preventExitTransition: O, nodeRef: j }, U.createElement("div", { id: R, onClick: a, className: F, ...L, style: o, ref: j }, U.createElement("div", { ...P && { role: m }, className: X(i) ? i({ type: s }) : ee("Toastify__toast-body", i), style: r }, w != null && U.createElement("div", { className: ee("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !I }) }, w), U.createElement("div", null, g)), te, U.createElement(Je, { ...u && !G ? { key: `pb-${u}` } : {}, rtl: C, theme: z, delay: d, isRunning: f, isIn: P, closeToast: p, hide: v, type: s, style: _, className: c, controlledProgress: G, progress: M || 0 })));
}, _e = function(e, f) {
  return f === void 0 && (f = !1), { enter: `Toastify--animate Toastify__${e}-enter`, exit: `Toastify--animate Toastify__${e}-exit`, appendPosition: f };
}, Ve = Te(_e("bounce", !0)), yt = Te(_e("slide", !0));
Te(_e("zoom"));
Te(_e("flip"));
const Ne = Fe((e, f) => {
  const { getToastToRender: O, containerRef: j, isToastActive: L } = Ge(e), { className: x, style: g, rtl: d, containerId: a } = e;
  function s(v) {
    const p = ee("Toastify__toast-container", `Toastify__toast-container--${v}`, { "Toastify__toast-container--rtl": d });
    return X(x) ? x({ position: v, rtl: d, defaultClassName: p }) : ee(p, ye(x));
  }
  return ae(() => {
    f && (f.current = j.current);
  }, []), U.createElement("div", { ref: j, className: "Toastify", id: a }, O((v, p) => {
    const b = p.length ? { ...g } : { ...g, pointerEvents: "none" };
    return U.createElement("div", { className: s(v), style: b, key: `container-${v}` }, p.map((t, n) => {
      let { content: o, props: i } = t;
      return U.createElement(Ze, { ...i, isIn: L(i.toastId), style: { ...i.style, "--nth": n + 1, "--len": p.length }, key: `toast-${i.key}` }, o);
    }));
  }));
});
Ne.displayName = "ToastContainer", Ne.defaultProps = { position: "top-right", transition: Ve, autoClose: 5e3, closeButton: ze, pauseOnHover: !0, pauseOnFocusLoss: !0, closeOnClick: !0, draggable: !0, draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light" };
let Me, re = /* @__PURE__ */ new Map(), ce = [], et = 1;
function Be() {
  return "" + et++;
}
function tt(e) {
  return e && (ie(e.toastId) || le(e.toastId)) ? e.toastId : Be();
}
function de(e, f) {
  return re.size > 0 ? q.emit(0, e, f) : ce.push({ content: e, options: f }), f.toastId;
}
function ge(e, f) {
  return { ...f, type: f && f.type || e, toastId: tt(f) };
}
function me(e) {
  return (f, O) => de(f, ge(e, O));
}
function W(e, f) {
  return de(e, ge("default", f));
}
W.loading = (e, f) => de(e, ge("default", { isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1, ...f })), W.promise = function(e, f, O) {
  let j, { pending: L, error: x, success: g } = f;
  L && (j = ie(L) ? W.loading(L, O) : W.loading(L.render, { ...O, ...L }));
  const d = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, a = (v, p, b) => {
    if (p == null)
      return void W.dismiss(j);
    const t = { type: v, ...d, ...O, data: b }, n = ie(p) ? { render: p } : p;
    return j ? W.update(j, { ...t, ...n }) : W(n.render, { ...t, ...n }), b;
  }, s = X(e) ? e() : e;
  return s.then((v) => a("success", g, v)).catch((v) => a("error", x, v)), s;
}, W.success = me("success"), W.info = me("info"), W.error = me("error"), W.warning = me("warning"), W.warn = W.warning, W.dark = (e, f) => de(e, ge("default", { theme: "dark", ...f })), W.dismiss = (e) => {
  re.size > 0 ? q.emit(1, e) : ce = ce.filter((f) => e != null && f.options.toastId !== e);
}, W.clearWaitingQueue = function(e) {
  return e === void 0 && (e = {}), q.emit(5, e);
}, W.isActive = (e) => {
  let f = !1;
  return re.forEach((O) => {
    O.isToastActive && O.isToastActive(e) && (f = !0);
  }), f;
}, W.update = function(e, f) {
  f === void 0 && (f = {}), setTimeout(() => {
    const O = function(j, L) {
      let { containerId: x } = L;
      const g = re.get(x || Me);
      return g && g.getToast(j);
    }(e, f);
    if (O) {
      const { props: j, content: L } = O, x = { delay: 100, ...j, ...f, toastId: f.toastId || e, updateId: Be() };
      x.toastId !== e && (x.staleId = e);
      const g = x.render || L;
      delete x.render, de(g, x);
    }
  }, 0);
}, W.done = (e) => {
  W.update(e, { progress: 1 });
}, W.onChange = (e) => (q.on(4, e), () => {
  q.off(4, e);
}), W.POSITION = { TOP_LEFT: "top-left", TOP_RIGHT: "top-right", TOP_CENTER: "top-center", BOTTOM_LEFT: "bottom-left", BOTTOM_RIGHT: "bottom-right", BOTTOM_CENTER: "bottom-center" }, W.TYPE = { INFO: "info", SUCCESS: "success", WARNING: "warning", ERROR: "error", DEFAULT: "default" }, q.on(2, (e) => {
  Me = e.containerId || e, re.set(Me, e), ce.forEach((f) => {
    q.emit(0, f.content, f.options);
  }), ce = [];
}).on(3, (e) => {
  re.delete(e.containerId || e), re.size === 0 && q.off(0).off(1).off(5);
});
const je = ({
  children: e
}) => /* @__PURE__ */ be("div", { className: "text-sm-multiline flex w-full max-w-[740px] items-center gap-5 rounded-xl bg-grey-transparent-09 py-4 px-6 text-white drop-shadow-m", children: e }), nt = ({ children: e }) => /* @__PURE__ */ be("div", { className: "flex flex-col", children: e }), rt = ({ children: e }) => /* @__PURE__ */ be("span", { className: "text-sm text-grey-03", children: e }), at = ({ children: e }) => /* @__PURE__ */ be("span", { className: "text-sm-medium text-white", children: e });
je.Body = nt;
je.Message = rt;
je.Title = at;
var ot = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Se = {}, st = {
  get exports() {
    return Se;
  },
  set exports(e) {
    Se = e;
  }
};
(function(e, f) {
  (function(j, L) {
    e.exports = L(U);
  })(ot, (O) => (
    /******/
    (() => {
      var j = {
        /***/
        "./node_modules/css-mediaquery/index.js": (
          /*!**********************************************!*\
            !*** ./node_modules/css-mediaquery/index.js ***!
            \**********************************************/
          /***/
          (d, a) => {
            a.match = n, a.parse = o;
            var s = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, v = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, p = /^(?:(min|max)-)?(.+)/, b = /(em|rem|px|cm|mm|in|pt|pc)?$/, t = /(dpi|dpcm|dppx)?$/;
            function n(_, u) {
              return o(_).some(function(m) {
                var M = m.inverse, C = m.type === "all" || u.type === m.type;
                if (C && M || !(C || M))
                  return !1;
                var R = m.expressions.every(function(y) {
                  var P = y.feature, I = y.modifier, w = y.value, E = u[P];
                  if (!E)
                    return !1;
                  switch (P) {
                    case "orientation":
                    case "scan":
                      return E.toLowerCase() === w.toLowerCase();
                    case "width":
                    case "height":
                    case "device-width":
                    case "device-height":
                      w = c(w), E = c(E);
                      break;
                    case "resolution":
                      w = r(w), E = r(E);
                      break;
                    case "aspect-ratio":
                    case "device-aspect-ratio":
                    case /* Deprecated */
                    "device-pixel-ratio":
                      w = i(w), E = i(E);
                      break;
                    case "grid":
                    case "color":
                    case "color-index":
                    case "monochrome":
                      w = parseInt(w, 10) || 1, E = parseInt(E, 10) || 0;
                      break;
                  }
                  switch (I) {
                    case "min":
                      return E >= w;
                    case "max":
                      return E <= w;
                    default:
                      return E === w;
                  }
                });
                return R && !M || !R && M;
              });
            }
            function o(_) {
              return _.split(",").map(function(u) {
                u = u.trim();
                var m = u.match(s), M = m[1], C = m[2], R = m[3] || "", y = {};
                return y.inverse = !!M && M.toLowerCase() === "not", y.type = C ? C.toLowerCase() : "all", R = R.match(/\([^\)]+\)/g) || [], y.expressions = R.map(function(P) {
                  var I = P.match(v), w = I[1].toLowerCase().match(p);
                  return {
                    modifier: w[1],
                    feature: w[2],
                    value: I[2]
                  };
                }), y;
              });
            }
            function i(_) {
              var u = Number(_), m;
              return u || (m = _.match(/^(\d+)\s*\/\s*(\d+)$/), u = m[1] / m[2]), u;
            }
            function r(_) {
              var u = parseFloat(_), m = String(_).match(t)[1];
              switch (m) {
                case "dpcm":
                  return u / 2.54;
                case "dppx":
                  return u * 96;
                default:
                  return u;
              }
            }
            function c(_) {
              var u = parseFloat(_), m = String(_).match(b)[1];
              switch (m) {
                case "em":
                  return u * 16;
                case "rem":
                  return u * 16;
                case "cm":
                  return u * 96 / 2.54;
                case "mm":
                  return u * 96 / 2.54 / 10;
                case "in":
                  return u * 96;
                case "pt":
                  return u * 72;
                case "pc":
                  return u * 72 / 12;
                default:
                  return u;
              }
            }
          }
        ),
        /***/
        "./node_modules/hyphenate-style-name/index.js": (
          /*!****************************************************!*\
            !*** ./node_modules/hyphenate-style-name/index.js ***!
            \****************************************************/
          /***/
          (d, a, s) => {
            s.r(a), s.d(a, {
              /* harmony export */
              default: () => o
              /* harmony export */
            });
            var v = /[A-Z]/g, p = /^ms-/, b = {};
            function t(i) {
              return "-" + i.toLowerCase();
            }
            function n(i) {
              if (b.hasOwnProperty(i))
                return b[i];
              var r = i.replace(v, t);
              return b[i] = p.test(r) ? "-" + r : r;
            }
            const o = n;
          }
        ),
        /***/
        "./node_modules/matchmediaquery/index.js": (
          /*!***********************************************!*\
            !*** ./node_modules/matchmediaquery/index.js ***!
            \***********************************************/
          /***/
          (d, a, s) => {
            var v = s(
              /*! css-mediaquery */
              "./node_modules/css-mediaquery/index.js"
            ).match, p = typeof window < "u" ? window.matchMedia : null;
            function b(n, o, i) {
              var r = this;
              if (p && !i) {
                var c = p.call(window, n);
                this.matches = c.matches, this.media = c.media, c.addListener(m);
              } else
                this.matches = v(n, o), this.media = n;
              this.addListener = _, this.removeListener = u, this.dispose = M;
              function _(C) {
                c && c.addListener(C);
              }
              function u(C) {
                c && c.removeListener(C);
              }
              function m(C) {
                r.matches = C.matches, r.media = C.media;
              }
              function M() {
                c && c.removeListener(m);
              }
            }
            function t(n, o, i) {
              return new b(n, o, i);
            }
            d.exports = t;
          }
        ),
        /***/
        "./node_modules/object-assign/index.js": (
          /*!*********************************************!*\
            !*** ./node_modules/object-assign/index.js ***!
            \*********************************************/
          /***/
          (d) => {
            /*
            object-assign
            (c) Sindre Sorhus
            @license MIT
            */
            var a = Object.getOwnPropertySymbols, s = Object.prototype.hasOwnProperty, v = Object.prototype.propertyIsEnumerable;
            function p(t) {
              if (t == null)
                throw new TypeError("Object.assign cannot be called with null or undefined");
              return Object(t);
            }
            function b() {
              try {
                if (!Object.assign)
                  return !1;
                var t = new String("abc");
                if (t[5] = "de", Object.getOwnPropertyNames(t)[0] === "5")
                  return !1;
                for (var n = {}, o = 0; o < 10; o++)
                  n["_" + String.fromCharCode(o)] = o;
                var i = Object.getOwnPropertyNames(n).map(function(c) {
                  return n[c];
                });
                if (i.join("") !== "0123456789")
                  return !1;
                var r = {};
                return "abcdefghijklmnopqrst".split("").forEach(function(c) {
                  r[c] = c;
                }), Object.keys(Object.assign({}, r)).join("") === "abcdefghijklmnopqrst";
              } catch {
                return !1;
              }
            }
            d.exports = b() ? Object.assign : function(t, n) {
              for (var o, i = p(t), r, c = 1; c < arguments.length; c++) {
                o = Object(arguments[c]);
                for (var _ in o)
                  s.call(o, _) && (i[_] = o[_]);
                if (a) {
                  r = a(o);
                  for (var u = 0; u < r.length; u++)
                    v.call(o, r[u]) && (i[r[u]] = o[r[u]]);
                }
              }
              return i;
            };
          }
        ),
        /***/
        "./node_modules/prop-types/checkPropTypes.js": (
          /*!***************************************************!*\
            !*** ./node_modules/prop-types/checkPropTypes.js ***!
            \***************************************************/
          /***/
          (d, a, s) => {
            var v = function() {
            };
            {
              var p = s(
                /*! ./lib/ReactPropTypesSecret */
                "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
              ), b = {}, t = s(
                /*! ./lib/has */
                "./node_modules/prop-types/lib/has.js"
              );
              v = function(o) {
                var i = "Warning: " + o;
                typeof console < "u" && console.error(i);
                try {
                  throw new Error(i);
                } catch {
                }
              };
            }
            function n(o, i, r, c, _) {
              for (var u in o)
                if (t(o, u)) {
                  var m;
                  try {
                    if (typeof o[u] != "function") {
                      var M = Error(
                        (c || "React class") + ": " + r + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                      );
                      throw M.name = "Invariant Violation", M;
                    }
                    m = o[u](i, u, c, r, null, p);
                  } catch (R) {
                    m = R;
                  }
                  if (m && !(m instanceof Error) && v(
                    (c || "React class") + ": type specification of " + r + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof m + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
                  ), m instanceof Error && !(m.message in b)) {
                    b[m.message] = !0;
                    var C = _ ? _() : "";
                    v(
                      "Failed " + r + " type: " + m.message + (C ?? "")
                    );
                  }
                }
            }
            n.resetWarningCache = function() {
              b = {};
            }, d.exports = n;
          }
        ),
        /***/
        "./node_modules/prop-types/factoryWithTypeCheckers.js": (
          /*!************************************************************!*\
            !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
            \************************************************************/
          /***/
          (d, a, s) => {
            var v = s(
              /*! react-is */
              "./node_modules/react-is/index.js"
            ), p = s(
              /*! object-assign */
              "./node_modules/object-assign/index.js"
            ), b = s(
              /*! ./lib/ReactPropTypesSecret */
              "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
            ), t = s(
              /*! ./lib/has */
              "./node_modules/prop-types/lib/has.js"
            ), n = s(
              /*! ./checkPropTypes */
              "./node_modules/prop-types/checkPropTypes.js"
            ), o = function() {
            };
            o = function(r) {
              var c = "Warning: " + r;
              typeof console < "u" && console.error(c);
              try {
                throw new Error(c);
              } catch {
              }
            };
            function i() {
              return null;
            }
            d.exports = function(r, c) {
              var _ = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
              function m(l) {
                var T = l && (_ && l[_] || l[u]);
                if (typeof T == "function")
                  return T;
              }
              var M = "<<anonymous>>", C = {
                array: I("array"),
                bigint: I("bigint"),
                bool: I("boolean"),
                func: I("function"),
                number: I("number"),
                object: I("object"),
                string: I("string"),
                symbol: I("symbol"),
                any: w(),
                arrayOf: E,
                element: z(),
                elementType: H(),
                instanceOf: F,
                node: Ee(),
                objectOf: J,
                oneOf: G,
                oneOfType: te,
                shape: Oe,
                exact: Ce
              };
              function R(l, T) {
                return l === T ? l !== 0 || 1 / l === 1 / T : l !== l && T !== T;
              }
              function y(l, T) {
                this.message = l, this.data = T && typeof T == "object" ? T : {}, this.stack = "";
              }
              y.prototype = Error.prototype;
              function P(l) {
                var T = {}, k = 0;
                function D(Q, A, $, N, B, Y, h) {
                  if (N = N || M, Y = Y || $, h !== b) {
                    if (c) {
                      var K = new Error(
                        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
                      );
                      throw K.name = "Invariant Violation", K;
                    } else if (typeof console < "u") {
                      var Z = N + ":" + $;
                      !T[Z] && // Avoid spamming the console because they are often not actionable except for lib authors
                      k < 3 && (o(
                        "You are manually calling a React.PropTypes validation function for the `" + Y + "` prop on `" + N + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                      ), T[Z] = !0, k++);
                    }
                  }
                  return A[$] == null ? Q ? A[$] === null ? new y("The " + B + " `" + Y + "` is marked as required " + ("in `" + N + "`, but its value is `null`.")) : new y("The " + B + " `" + Y + "` is marked as required in " + ("`" + N + "`, but its value is `undefined`.")) : null : l(A, $, N, B, Y);
                }
                var S = D.bind(null, !1);
                return S.isRequired = D.bind(null, !0), S;
              }
              function I(l) {
                function T(k, D, S, Q, A, $) {
                  var N = k[D], B = V(N);
                  if (B !== l) {
                    var Y = ne(N);
                    return new y(
                      "Invalid " + Q + " `" + A + "` of type " + ("`" + Y + "` supplied to `" + S + "`, expected ") + ("`" + l + "`."),
                      { expectedType: l }
                    );
                  }
                  return null;
                }
                return P(T);
              }
              function w() {
                return P(i);
              }
              function E(l) {
                function T(k, D, S, Q, A) {
                  if (typeof l != "function")
                    return new y("Property `" + A + "` of component `" + S + "` has invalid PropType notation inside arrayOf.");
                  var $ = k[D];
                  if (!Array.isArray($)) {
                    var N = V($);
                    return new y("Invalid " + Q + " `" + A + "` of type " + ("`" + N + "` supplied to `" + S + "`, expected an array."));
                  }
                  for (var B = 0; B < $.length; B++) {
                    var Y = l($, B, S, Q, A + "[" + B + "]", b);
                    if (Y instanceof Error)
                      return Y;
                  }
                  return null;
                }
                return P(T);
              }
              function z() {
                function l(T, k, D, S, Q) {
                  var A = T[k];
                  if (!r(A)) {
                    var $ = V(A);
                    return new y("Invalid " + S + " `" + Q + "` of type " + ("`" + $ + "` supplied to `" + D + "`, expected a single ReactElement."));
                  }
                  return null;
                }
                return P(l);
              }
              function H() {
                function l(T, k, D, S, Q) {
                  var A = T[k];
                  if (!v.isValidElementType(A)) {
                    var $ = V(A);
                    return new y("Invalid " + S + " `" + Q + "` of type " + ("`" + $ + "` supplied to `" + D + "`, expected a single ReactElement type."));
                  }
                  return null;
                }
                return P(l);
              }
              function F(l) {
                function T(k, D, S, Q, A) {
                  if (!(k[D] instanceof l)) {
                    var $ = l.name || M, N = pe(k[D]);
                    return new y("Invalid " + Q + " `" + A + "` of type " + ("`" + N + "` supplied to `" + S + "`, expected ") + ("instance of `" + $ + "`."));
                  }
                  return null;
                }
                return P(T);
              }
              function G(l) {
                if (!Array.isArray(l))
                  return arguments.length > 1 ? o(
                    "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
                  ) : o("Invalid argument supplied to oneOf, expected an array."), i;
                function T(k, D, S, Q, A) {
                  for (var $ = k[D], N = 0; N < l.length; N++)
                    if (R($, l[N]))
                      return null;
                  var B = JSON.stringify(l, function(h, K) {
                    var Z = ne(K);
                    return Z === "symbol" ? String(K) : K;
                  });
                  return new y("Invalid " + Q + " `" + A + "` of value `" + String($) + "` " + ("supplied to `" + S + "`, expected one of " + B + "."));
                }
                return P(T);
              }
              function J(l) {
                function T(k, D, S, Q, A) {
                  if (typeof l != "function")
                    return new y("Property `" + A + "` of component `" + S + "` has invalid PropType notation inside objectOf.");
                  var $ = k[D], N = V($);
                  if (N !== "object")
                    return new y("Invalid " + Q + " `" + A + "` of type " + ("`" + N + "` supplied to `" + S + "`, expected an object."));
                  for (var B in $)
                    if (t($, B)) {
                      var Y = l($, B, S, Q, A + "." + B, b);
                      if (Y instanceof Error)
                        return Y;
                    }
                  return null;
                }
                return P(T);
              }
              function te(l) {
                if (!Array.isArray(l))
                  return o("Invalid argument supplied to oneOfType, expected an instance of array."), i;
                for (var T = 0; T < l.length; T++) {
                  var k = l[T];
                  if (typeof k != "function")
                    return o(
                      "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + xe(k) + " at index " + T + "."
                    ), i;
                }
                function D(S, Q, A, $, N) {
                  for (var B = [], Y = 0; Y < l.length; Y++) {
                    var h = l[Y], K = h(S, Q, A, $, N, b);
                    if (K == null)
                      return null;
                    K.data && t(K.data, "expectedType") && B.push(K.data.expectedType);
                  }
                  var Z = B.length > 0 ? ", expected one of type [" + B.join(", ") + "]" : "";
                  return new y("Invalid " + $ + " `" + N + "` supplied to " + ("`" + A + "`" + Z + "."));
                }
                return P(D);
              }
              function Ee() {
                function l(T, k, D, S, Q) {
                  return ue(T[k]) ? null : new y("Invalid " + S + " `" + Q + "` supplied to " + ("`" + D + "`, expected a ReactNode."));
                }
                return P(l);
              }
              function fe(l, T, k, D, S) {
                return new y(
                  (l || "React class") + ": " + T + " type `" + k + "." + D + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + S + "`."
                );
              }
              function Oe(l) {
                function T(k, D, S, Q, A) {
                  var $ = k[D], N = V($);
                  if (N !== "object")
                    return new y("Invalid " + Q + " `" + A + "` of type `" + N + "` " + ("supplied to `" + S + "`, expected `object`."));
                  for (var B in l) {
                    var Y = l[B];
                    if (typeof Y != "function")
                      return fe(S, Q, A, B, ne(Y));
                    var h = Y($, B, S, Q, A + "." + B, b);
                    if (h)
                      return h;
                  }
                  return null;
                }
                return P(T);
              }
              function Ce(l) {
                function T(k, D, S, Q, A) {
                  var $ = k[D], N = V($);
                  if (N !== "object")
                    return new y("Invalid " + Q + " `" + A + "` of type `" + N + "` " + ("supplied to `" + S + "`, expected `object`."));
                  var B = p({}, k[D], l);
                  for (var Y in B) {
                    var h = l[Y];
                    if (t(l, Y) && typeof h != "function")
                      return fe(S, Q, A, Y, ne(h));
                    if (!h)
                      return new y(
                        "Invalid " + Q + " `" + A + "` key `" + Y + "` supplied to `" + S + "`.\nBad object: " + JSON.stringify(k[D], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(l), null, "  ")
                      );
                    var K = h($, Y, S, Q, A + "." + Y, b);
                    if (K)
                      return K;
                  }
                  return null;
                }
                return P(T);
              }
              function ue(l) {
                switch (typeof l) {
                  case "number":
                  case "string":
                  case "undefined":
                    return !0;
                  case "boolean":
                    return !l;
                  case "object":
                    if (Array.isArray(l))
                      return l.every(ue);
                    if (l === null || r(l))
                      return !0;
                    var T = m(l);
                    if (T) {
                      var k = T.call(l), D;
                      if (T !== l.entries) {
                        for (; !(D = k.next()).done; )
                          if (!ue(D.value))
                            return !1;
                      } else
                        for (; !(D = k.next()).done; ) {
                          var S = D.value;
                          if (S && !ue(S[1]))
                            return !1;
                        }
                    } else
                      return !1;
                    return !0;
                  default:
                    return !1;
                }
              }
              function we(l, T) {
                return l === "symbol" ? !0 : T ? T["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && T instanceof Symbol : !1;
              }
              function V(l) {
                var T = typeof l;
                return Array.isArray(l) ? "array" : l instanceof RegExp ? "object" : we(T, l) ? "symbol" : T;
              }
              function ne(l) {
                if (typeof l > "u" || l === null)
                  return "" + l;
                var T = V(l);
                if (T === "object") {
                  if (l instanceof Date)
                    return "date";
                  if (l instanceof RegExp)
                    return "regexp";
                }
                return T;
              }
              function xe(l) {
                var T = ne(l);
                switch (T) {
                  case "array":
                  case "object":
                    return "an " + T;
                  case "boolean":
                  case "date":
                  case "regexp":
                    return "a " + T;
                  default:
                    return T;
                }
              }
              function pe(l) {
                return !l.constructor || !l.constructor.name ? M : l.constructor.name;
              }
              return C.checkPropTypes = n, C.resetWarningCache = n.resetWarningCache, C.PropTypes = C, C;
            };
          }
        ),
        /***/
        "./node_modules/prop-types/index.js": (
          /*!******************************************!*\
            !*** ./node_modules/prop-types/index.js ***!
            \******************************************/
          /***/
          (d, a, s) => {
            {
              var v = s(
                /*! react-is */
                "./node_modules/react-is/index.js"
              ), p = !0;
              d.exports = s(
                /*! ./factoryWithTypeCheckers */
                "./node_modules/prop-types/factoryWithTypeCheckers.js"
              )(v.isElement, p);
            }
          }
        ),
        /***/
        "./node_modules/prop-types/lib/ReactPropTypesSecret.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
            \*************************************************************/
          /***/
          (d) => {
            var a = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
            d.exports = a;
          }
        ),
        /***/
        "./node_modules/prop-types/lib/has.js": (
          /*!********************************************!*\
            !*** ./node_modules/prop-types/lib/has.js ***!
            \********************************************/
          /***/
          (d) => {
            d.exports = Function.call.bind(Object.prototype.hasOwnProperty);
          }
        ),
        /***/
        "./node_modules/react-is/cjs/react-is.development.js": (
          /*!***********************************************************!*\
            !*** ./node_modules/react-is/cjs/react-is.development.js ***!
            \***********************************************************/
          /***/
          (d, a) => {
            /** @license React v16.13.1
             * react-is.development.js
             *
             * Copyright (c) Facebook, Inc. and its affiliates.
             *
             * This source code is licensed under the MIT license found in the
             * LICENSE file in the root directory of this source tree.
             */
            (function() {
              var s = typeof Symbol == "function" && Symbol.for, v = s ? Symbol.for("react.element") : 60103, p = s ? Symbol.for("react.portal") : 60106, b = s ? Symbol.for("react.fragment") : 60107, t = s ? Symbol.for("react.strict_mode") : 60108, n = s ? Symbol.for("react.profiler") : 60114, o = s ? Symbol.for("react.provider") : 60109, i = s ? Symbol.for("react.context") : 60110, r = s ? Symbol.for("react.async_mode") : 60111, c = s ? Symbol.for("react.concurrent_mode") : 60111, _ = s ? Symbol.for("react.forward_ref") : 60112, u = s ? Symbol.for("react.suspense") : 60113, m = s ? Symbol.for("react.suspense_list") : 60120, M = s ? Symbol.for("react.memo") : 60115, C = s ? Symbol.for("react.lazy") : 60116, R = s ? Symbol.for("react.block") : 60121, y = s ? Symbol.for("react.fundamental") : 60117, P = s ? Symbol.for("react.responder") : 60118, I = s ? Symbol.for("react.scope") : 60119;
              function w(h) {
                return typeof h == "string" || typeof h == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                h === b || h === c || h === n || h === t || h === u || h === m || typeof h == "object" && h !== null && (h.$$typeof === C || h.$$typeof === M || h.$$typeof === o || h.$$typeof === i || h.$$typeof === _ || h.$$typeof === y || h.$$typeof === P || h.$$typeof === I || h.$$typeof === R);
              }
              function E(h) {
                if (typeof h == "object" && h !== null) {
                  var K = h.$$typeof;
                  switch (K) {
                    case v:
                      var Z = h.type;
                      switch (Z) {
                        case r:
                        case c:
                        case b:
                        case n:
                        case t:
                        case u:
                          return Z;
                        default:
                          var Le = Z && Z.$$typeof;
                          switch (Le) {
                            case i:
                            case _:
                            case C:
                            case M:
                            case o:
                              return Le;
                            default:
                              return K;
                          }
                      }
                    case p:
                      return K;
                  }
                }
              }
              var z = r, H = c, F = i, G = o, J = v, te = _, Ee = b, fe = C, Oe = M, Ce = p, ue = n, we = t, V = u, ne = !1;
              function xe(h) {
                return ne || (ne = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), pe(h) || E(h) === r;
              }
              function pe(h) {
                return E(h) === c;
              }
              function l(h) {
                return E(h) === i;
              }
              function T(h) {
                return E(h) === o;
              }
              function k(h) {
                return typeof h == "object" && h !== null && h.$$typeof === v;
              }
              function D(h) {
                return E(h) === _;
              }
              function S(h) {
                return E(h) === b;
              }
              function Q(h) {
                return E(h) === C;
              }
              function A(h) {
                return E(h) === M;
              }
              function $(h) {
                return E(h) === p;
              }
              function N(h) {
                return E(h) === n;
              }
              function B(h) {
                return E(h) === t;
              }
              function Y(h) {
                return E(h) === u;
              }
              a.AsyncMode = z, a.ConcurrentMode = H, a.ContextConsumer = F, a.ContextProvider = G, a.Element = J, a.ForwardRef = te, a.Fragment = Ee, a.Lazy = fe, a.Memo = Oe, a.Portal = Ce, a.Profiler = ue, a.StrictMode = we, a.Suspense = V, a.isAsyncMode = xe, a.isConcurrentMode = pe, a.isContextConsumer = l, a.isContextProvider = T, a.isElement = k, a.isForwardRef = D, a.isFragment = S, a.isLazy = Q, a.isMemo = A, a.isPortal = $, a.isProfiler = N, a.isStrictMode = B, a.isSuspense = Y, a.isValidElementType = w, a.typeOf = E;
            })();
          }
        ),
        /***/
        "./node_modules/react-is/index.js": (
          /*!****************************************!*\
            !*** ./node_modules/react-is/index.js ***!
            \****************************************/
          /***/
          (d, a, s) => {
            d.exports = s(
              /*! ./cjs/react-is.development.js */
              "./node_modules/react-is/cjs/react-is.development.js"
            );
          }
        ),
        /***/
        "./node_modules/shallow-equal/dist/index.esm.js": (
          /*!******************************************************!*\
            !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
            \******************************************************/
          /***/
          (d, a, s) => {
            s.r(a), s.d(a, {
              /* harmony export */
              shallowEqualArrays: () => (
                /* binding */
                p
              ),
              /* harmony export */
              shallowEqualObjects: () => (
                /* binding */
                v
              )
              /* harmony export */
            });
            function v(b, t) {
              if (b === t)
                return !0;
              if (!b || !t)
                return !1;
              var n = Object.keys(b), o = Object.keys(t), i = n.length;
              if (o.length !== i)
                return !1;
              for (var r = 0; r < i; r++) {
                var c = n[r];
                if (b[c] !== t[c] || !Object.prototype.hasOwnProperty.call(t, c))
                  return !1;
              }
              return !0;
            }
            function p(b, t) {
              if (b === t)
                return !0;
              if (!b || !t)
                return !1;
              var n = b.length;
              if (t.length !== n)
                return !1;
              for (var o = 0; o < n; o++)
                if (b[o] !== t[o])
                  return !1;
              return !0;
            }
          }
        ),
        /***/
        "./src/Component.ts": (
          /*!**************************!*\
            !*** ./src/Component.ts ***!
            \**************************/
          /***/
          function(d, a, s) {
            var v = this && this.__rest || function(n, o) {
              var i = {};
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && o.indexOf(r) < 0 && (i[r] = n[r]);
              if (n != null && typeof Object.getOwnPropertySymbols == "function")
                for (var c = 0, r = Object.getOwnPropertySymbols(n); c < r.length; c++)
                  o.indexOf(r[c]) < 0 && Object.prototype.propertyIsEnumerable.call(n, r[c]) && (i[r[c]] = n[r[c]]);
              return i;
            }, p = this && this.__importDefault || function(n) {
              return n && n.__esModule ? n : { default: n };
            };
            Object.defineProperty(a, "__esModule", { value: !0 });
            var b = p(s(
              /*! ./useMediaQuery */
              "./src/useMediaQuery.ts"
            )), t = function(n) {
              var o = n.children, i = n.device, r = n.onChange, c = v(n, ["children", "device", "onChange"]), _ = (0, b.default)(c, i, r);
              return typeof o == "function" ? o(_) : _ ? o : null;
            };
            a.default = t;
          }
        ),
        /***/
        "./src/Context.ts": (
          /*!************************!*\
            !*** ./src/Context.ts ***!
            \************************/
          /***/
          (d, a, s) => {
            Object.defineProperty(a, "__esModule", { value: !0 });
            var v = s(
              /*! react */
              "react"
            ), p = (0, v.createContext)(void 0);
            a.default = p;
          }
        ),
        /***/
        "./src/index.ts": (
          /*!**********************!*\
            !*** ./src/index.ts ***!
            \**********************/
          /***/
          function(d, a, s) {
            var v = this && this.__importDefault || function(o) {
              return o && o.__esModule ? o : { default: o };
            };
            Object.defineProperty(a, "__esModule", { value: !0 }), a.Context = a.toQuery = a.useMediaQuery = a.default = void 0;
            var p = v(s(
              /*! ./useMediaQuery */
              "./src/useMediaQuery.ts"
            ));
            a.useMediaQuery = p.default;
            var b = v(s(
              /*! ./Component */
              "./src/Component.ts"
            ));
            a.default = b.default;
            var t = v(s(
              /*! ./toQuery */
              "./src/toQuery.ts"
            ));
            a.toQuery = t.default;
            var n = v(s(
              /*! ./Context */
              "./src/Context.ts"
            ));
            a.Context = n.default;
          }
        ),
        /***/
        "./src/mediaQuery.ts": (
          /*!***************************!*\
            !*** ./src/mediaQuery.ts ***!
            \***************************/
          /***/
          function(d, a, s) {
            var v = this && this.__assign || function() {
              return v = Object.assign || function(u) {
                for (var m, M = 1, C = arguments.length; M < C; M++) {
                  m = arguments[M];
                  for (var R in m)
                    Object.prototype.hasOwnProperty.call(m, R) && (u[R] = m[R]);
                }
                return u;
              }, v.apply(this, arguments);
            }, p = this && this.__rest || function(u, m) {
              var M = {};
              for (var C in u)
                Object.prototype.hasOwnProperty.call(u, C) && m.indexOf(C) < 0 && (M[C] = u[C]);
              if (u != null && typeof Object.getOwnPropertySymbols == "function")
                for (var R = 0, C = Object.getOwnPropertySymbols(u); R < C.length; R++)
                  m.indexOf(C[R]) < 0 && Object.prototype.propertyIsEnumerable.call(u, C[R]) && (M[C[R]] = u[C[R]]);
              return M;
            }, b = this && this.__importDefault || function(u) {
              return u && u.__esModule ? u : { default: u };
            };
            Object.defineProperty(a, "__esModule", { value: !0 });
            var t = b(s(
              /*! prop-types */
              "./node_modules/prop-types/index.js"
            )), n = t.default.oneOfType([
              t.default.string,
              t.default.number
            ]), o = {
              all: t.default.bool,
              grid: t.default.bool,
              aural: t.default.bool,
              braille: t.default.bool,
              handheld: t.default.bool,
              print: t.default.bool,
              projection: t.default.bool,
              screen: t.default.bool,
              tty: t.default.bool,
              tv: t.default.bool,
              embossed: t.default.bool
            }, i = {
              orientation: t.default.oneOf([
                "portrait",
                "landscape"
              ]),
              scan: t.default.oneOf([
                "progressive",
                "interlace"
              ]),
              aspectRatio: t.default.string,
              deviceAspectRatio: t.default.string,
              height: n,
              deviceHeight: n,
              width: n,
              deviceWidth: n,
              color: t.default.bool,
              colorIndex: t.default.bool,
              monochrome: t.default.bool,
              resolution: n,
              type: Object.keys(o)
            };
            i.type;
            var r = p(
              i,
              ["type"]
            ), c = v({ minAspectRatio: t.default.string, maxAspectRatio: t.default.string, minDeviceAspectRatio: t.default.string, maxDeviceAspectRatio: t.default.string, minHeight: n, maxHeight: n, minDeviceHeight: n, maxDeviceHeight: n, minWidth: n, maxWidth: n, minDeviceWidth: n, maxDeviceWidth: n, minColor: t.default.number, maxColor: t.default.number, minColorIndex: t.default.number, maxColorIndex: t.default.number, minMonochrome: t.default.number, maxMonochrome: t.default.number, minResolution: n, maxResolution: n }, r), _ = v(v({}, o), c);
            a.default = {
              all: _,
              types: o,
              matchers: i,
              features: c
            };
          }
        ),
        /***/
        "./src/toQuery.ts": (
          /*!************************!*\
            !*** ./src/toQuery.ts ***!
            \************************/
          /***/
          function(d, a, s) {
            var v = this && this.__importDefault || function(r) {
              return r && r.__esModule ? r : { default: r };
            };
            Object.defineProperty(a, "__esModule", { value: !0 });
            var p = v(s(
              /*! hyphenate-style-name */
              "./node_modules/hyphenate-style-name/index.js"
            )), b = v(s(
              /*! ./mediaQuery */
              "./src/mediaQuery.ts"
            )), t = function(r) {
              return "not ".concat(r);
            }, n = function(r, c) {
              var _ = (0, p.default)(r);
              return typeof c == "number" && (c = "".concat(c, "px")), c === !0 ? _ : c === !1 ? t(_) : "(".concat(_, ": ").concat(c, ")");
            }, o = function(r) {
              return r.join(" and ");
            }, i = function(r) {
              var c = [];
              return Object.keys(b.default.all).forEach(function(_) {
                var u = r[_];
                u != null && c.push(n(_, u));
              }), o(c);
            };
            a.default = i;
          }
        ),
        /***/
        "./src/useMediaQuery.ts": (
          /*!******************************!*\
            !*** ./src/useMediaQuery.ts ***!
            \******************************/
          /***/
          function(d, a, s) {
            var v = this && this.__importDefault || function(y) {
              return y && y.__esModule ? y : { default: y };
            };
            Object.defineProperty(a, "__esModule", { value: !0 });
            var p = s(
              /*! react */
              "react"
            ), b = v(s(
              /*! matchmediaquery */
              "./node_modules/matchmediaquery/index.js"
            )), t = v(s(
              /*! hyphenate-style-name */
              "./node_modules/hyphenate-style-name/index.js"
            )), n = s(
              /*! shallow-equal */
              "./node_modules/shallow-equal/dist/index.esm.js"
            ), o = v(s(
              /*! ./toQuery */
              "./src/toQuery.ts"
            )), i = v(s(
              /*! ./Context */
              "./src/Context.ts"
            )), r = function(y) {
              return y.query || (0, o.default)(y);
            }, c = function(y) {
              if (y) {
                var P = Object.keys(y);
                return P.reduce(function(I, w) {
                  return I[(0, t.default)(w)] = y[w], I;
                }, {});
              }
            }, _ = function() {
              var y = (0, p.useRef)(!1);
              return (0, p.useEffect)(function() {
                y.current = !0;
              }, []), y.current;
            }, u = function(y) {
              var P = (0, p.useContext)(i.default), I = function() {
                return c(y) || c(P);
              }, w = (0, p.useState)(I), E = w[0], z = w[1];
              return (0, p.useEffect)(function() {
                var H = I();
                (0, n.shallowEqualObjects)(E, H) || z(H);
              }, [y, P]), E;
            }, m = function(y) {
              var P = function() {
                return r(y);
              }, I = (0, p.useState)(P), w = I[0], E = I[1];
              return (0, p.useEffect)(function() {
                var z = P();
                w !== z && E(z);
              }, [y]), w;
            }, M = function(y, P) {
              var I = function() {
                return (0, b.default)(y, P || {}, !!P);
              }, w = (0, p.useState)(I), E = w[0], z = w[1], H = _();
              return (0, p.useEffect)(function() {
                if (H) {
                  var F = I();
                  return z(F), function() {
                    F && F.dispose();
                  };
                }
              }, [y, P]), E;
            }, C = function(y) {
              var P = (0, p.useState)(y.matches), I = P[0], w = P[1];
              return (0, p.useEffect)(function() {
                var E = function(z) {
                  w(z.matches);
                };
                return y.addListener(E), w(y.matches), function() {
                  y.removeListener(E);
                };
              }, [y]), I;
            }, R = function(y, P, I) {
              var w = u(P), E = m(y);
              if (!E)
                throw new Error("Invalid or missing MediaQuery!");
              var z = M(E, w), H = C(z), F = _();
              return (0, p.useEffect)(function() {
                F && I && I(H);
              }, [H]), (0, p.useEffect)(function() {
                return function() {
                  z && z.dispose();
                };
              }, []), H;
            };
            a.default = R;
          }
        ),
        /***/
        react: (
          /*!**************************************************************************************!*\
            !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
            \**************************************************************************************/
          /***/
          (d) => {
            d.exports = O;
          }
        )
        /******/
      }, L = {};
      function x(d) {
        var a = L[d];
        if (a !== void 0)
          return a.exports;
        var s = L[d] = {
          /******/
          // no module.id needed
          /******/
          // no module.loaded needed
          /******/
          exports: {}
          /******/
        };
        return j[d].call(s.exports, s, s.exports, x), s.exports;
      }
      x.d = (d, a) => {
        for (var s in a)
          x.o(a, s) && !x.o(d, s) && Object.defineProperty(d, s, { enumerable: !0, get: a[s] });
      }, x.o = (d, a) => Object.prototype.hasOwnProperty.call(d, a), x.r = (d) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(d, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(d, "__esModule", { value: !0 });
      };
      var g = x("./src/index.ts");
      return g;
    })()
  ));
})(st);
const ht = () => Se.useMediaQuery({ query: "(max-width: 640px)" });
export {
  W as Q,
  je as T,
  dt as a,
  ft as b,
  lt as c,
  mt as d,
  vt as g,
  Ne as k,
  pt as t,
  ht as u,
  yt as w
};
//# sourceMappingURL=useMobile-11908957.mjs.map
